module.exports = __webpack_public_path__ + "static/media/banner_woman_chat_br.17e7bf2a.png";